import { KendoBaseComponent, KendoBaseDatasourceComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import TreeViewProps from './TreeViewProps'

import Animation from './Animation'
import Checkboxes from './Checkboxes'
import Messages from './Messages'

export default {
    props: TreeViewProps,
    render (h) {
        return h('ul',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        KendoSharedMethods,
        Animation,
        Checkboxes,
        Messages
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoTreeView(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeView()
        },
        _resolveChildren() {
            if(this.$options.propsData && !this.$options.propsData['dataSource'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-treeview-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/KendoTreeViewMixin.js